// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_en-3";
export var flatBottomCorners = "_en-5";
export var productImage = "_en-0";
export var quantityContainer = "_en-2";
export var quantityHeader = "_en-6";
export var tooltip = "_en-1";
export var wrapAndEllipsesOverflow = "_en-4";